import { Component } from "react";
import CenterBox from "../../components/CenterBox";

import "./LoadingRoom.css";

class LoadingRoom extends Component {
    render() {
        const { connectionStatus, retryCount, maxRetries } = this.props;

        // Default status messages
        const statusMessages = {
            connecting: "Connecting to server...",
            connected: "Connected! Joining room...",
            retrying: `Retrying... (${retryCount}/${maxRetries})`,
            waiting: "Waiting for response..."
        };

        const message = statusMessages[connectionStatus] || "Connecting with the room...";
        const showRetryInfo = connectionStatus === "retrying" && retryCount > 0;

        return (
            <CenterBox cancel="Cancel" {...this.props}>
                <div className="message-box">
                    <div className="loading-spinner"></div>
                    <div className="loading-status">{message}</div>
                    {showRetryInfo && (
                        <div className="loading-retry-info">
                            Connection is slow. Please wait...
                        </div>
                    )}
                </div>
            </CenterBox>
        );
    }
}

export default LoadingRoom;
